import { createFileRoute } from '@tanstack/react-router'

import { ResendConfirmationPage } from '@/features/auth'

export const Route = createFileRoute('/_auth/resend-confirmation')({
  component: ResendConfirmationPage
})
